'use client'

import { sendGAEvent } from '@next/third-parties/google'
import { capturePostHogEvent } from './posthogClient'

export function captureAnalyticsEvent(eventName, properties = {}) {
  if (typeof window === 'undefined' || !eventName) return

  sendGAEvent('event', eventName, properties)
  capturePostHogEvent(eventName, properties)
}
